// extracted by mini-css-extract-plugin
module.exports = {"container":"_1qcG2BEvSaB-KH35fDzmoL","quote":"_2BuZS3DS2KCYL0dx_DHY8v","author":"_2kciU8tccxj4Sf5pcT1H7u"};